import { CompanyColumns } from '@miq/catalog';
export const COLUMNS_TO_STRING = [CompanyColumns.Location_ID];
export function setNumberWithoutCommaInTable(displayHeaders) {
  displayHeaders?.forEach(displayHeader => {
    // location id having commas in between due to integer, so setting string while displaying
    if (COLUMNS_TO_STRING.includes(displayHeader.columnId)) {
      displayHeader.dataType = 'string';
    }
  });
  return displayHeaders;
}
